import React from 'react';
import {Slider} from 'MWC';
import '../../less/apple-setup-card.less';
import '../../less/apple-setup-card-mobile.less';
import apple_wallet_img_1 from '../../img/apple_wallet_img_3.png';
import apple_wallet_img_2 from '../../img/apple_wallet_img_2.png';
import apple_wallet_img_3 from '../../img/apple_wallet_img_1.png';
import a241 from '../../img/a24_img_1.png';
import a242 from '../../img/a24_img_2.png';
import a243 from '../../img/a24_img_3.png';
import appWatch from '../../img/apple_watch.svg';

export default function template() {
    const appleWallet = (
            <div className="setup-card-body">
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 1
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_1_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 2
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_2_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 3
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WATCH_STEP_3_DESC')}</p>
                </div>
            </div>
        ),
        appleWalletSlider = (
            <Slider
                autoPlayInterval={5000}
                autoPlay
                showNavigation
            >
                <div className="slide">
                    <div className="slide-content">
                        <img src={apple_wallet_img_1} alt="" />
                    </div>
                </div>
                <div className="slide">
                    <div className="slide-content">
                        <img src={apple_wallet_img_2} alt="" />
                    </div>
                </div>
                <div className="slide">
                    <div className="slide-content">
                        <img src={apple_wallet_img_3} alt="" />
                    </div>
                </div>
            </Slider>
        ),
        a24 = (
            <div className="setup-card-body">
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 1
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_A24_STEP_1_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 2
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_A24_STEP_2_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 3
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_A24_STEP_3_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 4
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_A24_STEP_4_DESC')}</p>
                </div>
            </div>
        ),
        a24Slider = (
            <Slider
                autoPlayInterval={5000}
                autoPlay
                showNavigation
            >
                <div className="slide">
                    <div className="slide-content">
                        <img src={a241} alt="" />
                    </div>
                </div>
                <div className="slide">
                    <div className="slide-content">
                        <img src={a242} alt="" />
                    </div>
                </div>
                <div className="slide">
                    <div className="slide-content">
                        <img src={a243} alt="" />
                    </div>
                </div>
            </Slider>
        ),
        appleWatch = (
            <div className="setup-card-body">
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 1
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WATCH_STEP_1_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 2
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WATCH_STEP_2_DESC')}</p>
                </div>
                <div className="setup-card-item">
                    <p className="step">
                        {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET_STEP_TITLE')} 3
                    </p>
                    <p className="desc">{this.l10n('APPLE_PAY_SLOGAN_APPLE_WATCH_STEP_3_DESC')}</p>
                </div>
            </div>
        ),
        appleWatchSlider = (
            <div className="slide">
                <div className="slide-content">
                    <img src={appWatch} alt="" />
                </div>
            </div>
        ),
        current = this.state.apw ? appleWallet : this.state.ap24 ? a24 : appleWatch,
        currentSlider = this.state.apw
            ? appleWalletSlider
            : this.state.ap24
            ? a24Slider
            : appleWatchSlider;

    return (
        <div className="module-setup-card-container">
            <div className="main-setup-card-content">
                <div className="left-side">
                    <p className="setup-card-title">{this.l10n('APPLE_PAY_HELP_TITLE')}</p>
                    <div className="setup-card-container">
                        <div className="setup-card-head">
                            <p
                                onClick={() => this.toggle('apw')}
                                className={`${this.state.apw ? 'active' : ''}`}
                            >
                                {this.l10n('APPLE_PAY_SLOGAN_APPLE_WALLET')}
                            </p>
                            <p
                                onClick={() => this.toggle('ap24')}
                                className={`${this.state.ap24 ? 'active' : ''}`}
                            >
                                {this.l10n('APPLE_PAY_SLOGAN_A24')}
                            </p>
                            <p
                                onClick={() => this.toggle('apwch')}
                                className={`${this.state.apwch ? 'active' : ''}`}
                            >
                                {this.l10n('APPLE_PAY_SLOGAN_APPLE_WATCH')}
                            </p>
                        </div>
                        {current}
                    </div>
                </div>
                <div className="right-side">
                    <div className="module-setup-card-slider">{currentSlider}</div>
                </div>
            </div>
        </div>
    );
}
